import React, { useState } from 'react';
import { Container, Row, Col, Badge } from 'react-bootstrap';

const Hero = () => {
  const [hoveredIcon, setHoveredIcon] = useState(null);

  const techIcons = [
    { icon: 'fab fa-docker', color: '#2496ed', name: 'Docker' },
    { icon: 'fab fa-aws', color: '#ff9900', name: 'AWS' },
    { icon: 'fab fa-linux', color: '#fcc624', name: 'Linux' },
    { icon: 'fab fa-git-alt', color: '#f05032', name: 'Git' },
    { icon: 'fas fa-server', color: '#6236e8', name: 'Terraform' },
    { icon: 'fas fa-dharmachakra', color: '#326ce5', name: 'Kubernetes' }
  ];

  return (
    <section className="hero">
      <div className="hero-bg"></div>
      <div className="hero-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} lg={6} className="hero-left">
            <div className="hero-content">
              <h1>Aspiring DevOps Engineer & Cloud Enthusiast</h1>
              <p>BSCS graduate having a deep interest in DevOps & Cloud. Practical experience using Linux, Git/GitHub, Docker, Kubernetes, AWS Cloud Platform, Jenkins, and GitHub Actions.</p>
              <div className="hero-btns">
                <a href="#contact" className="btn btn-secondary">Get In Touch</a>
                <a 
                  href="/resume" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="btn btn-primary"
                >
                  <i className="fas fa-file-download" style={{ marginRight: '8px' }}></i>
                  View Resume
                </a>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} className="hero-right">
            <div className="hero-right-content">
              {/* Floating Tech Icons */}
              <div className="floating-tech-icons-container">
                {techIcons.map((tech, index) => (
                  <div
                    key={index}
                    className={`floating-tech-icon ${hoveredIcon === index ? 'active' : ''}`}
                    style={{
                      '--index': index,
                      '--color': tech.color,
                      '--delay': `${index * 0.3}s`
                    }}
                    onMouseEnter={() => setHoveredIcon(index)}
                    onMouseLeave={() => setHoveredIcon(null)}
                  >
                    <div className="tech-icon-wrapper">
                      <i className={tech.icon}></i>
                      {hoveredIcon === index && (
                        <Badge bg="transparent" className="tech-name-badge">{tech.name}</Badge>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <div className="scroll-indicator">
        <span></span>
      </div>
    </section>
  );
};

export default Hero;
